/* DON'T EDIT THIS FILE: edit original and run build again */ export const getUserFullName = ({
  firstName,
  lastName,
}: {
  firstName?: string | null;
  lastName?: string | null;
}) => {
  return firstName + " " + lastName;
};
